module.exports = __webpack_public_path__ + "chevron-yr.697facb0.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/chevron-yr.png
// module id = 479
// module chunks = 0